import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import MyContext from "../../../MyContext"; //using ContextAPI to store data dynamically
import NoIndex from "../../NoIndex";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import { FileText, ReceiptText ,BarChart2} from "lucide-react";
import "../AdminDashboard.css";
function AdminOrderSettlement({Admin}) {
  // State Management ##############################################################################################################################################################
    const navigate = useNavigate();
    
    const {baseUrl} = useContext(MyContext);
    const {config}= useContext(MyContext);
    const [Clients, setClients] = useState([]);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [error, setError] = useState(null);
    const [Lerror, setLerror] = useState(null);
    const [Loading, setLoading] = useState(false);
   // Api Calls Management ##############################################################################################################################################################
     // fetch All Client Api call
  const FetchClientCall = async () => {
    setLoading(true);
    try {
     
      const UserDetail = {
        // userid: User.pkid,
        userid: Admin.pkid,
        latitude: latitude,
        longitude: longitude,
      };

      const response = await axios.post(
        `${baseUrl}/api/Admin/getAllClientList`,
        UserDetail,
        config
      );
      if (response.data.responseCode === "00") {
        // toast.success(response.data.responseMessage);

        setClients(response.data.response);
   
        setLoading(false);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("error");
      console.error("Error updating Admin login:", error);
    } finally {
      setLoading(false);
    }
  };
    // useEffect Call for all Apis ###########################################################################################################################################################
  
    useEffect(() => {
      FetchClientCall();
    }, []);
      useEffect(() => {
        // Check if the Geolocation API is available
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              // Update latitude and longitude states
              setLatitude(position.coords.latitude);
              setLongitude(position.coords.longitude);
            },
            (err) => {
              setLerror(err.message);
            }
          );
        } else {
          setError("Geolocation is not supported by your browser");
        }
      }, []);
      // filter ##################################################################################################################################################################
      const [search, setSearch] = useState('');
      const [statusFilter, setStatusFilter] = useState('');
      const [dateFilter, setDateFilter] = useState('');
      
      const filteredClients = Clients?.filter((client) => {
        // Ensure all fields exist before filtering
        const orgName = client?.organization_name?.toLowerCase() || "";
        const status = client?.us_status || "";
        const lastLogin = client?.us_last_login || "";
      
        const matchSearch = orgName.includes(search.toLowerCase());
        const matchStatus = statusFilter ? status === statusFilter : true;
        const matchDate = dateFilter ? lastLogin.includes(dateFilter) : true;
      
        return matchSearch && matchStatus && matchDate;
      });
      // On Clicks function ##################################################################################################################################################################
      const viewSettlement = (clientId ,clientName) => {
        // Navigate to the client's dashboard page with the client ID
        navigate(`/admin/orders/settlement/${clientId}/${clientName}`);
      };
        const viewPayoutReport = (clientId ,clientName) => {
        // Navigate to the client's dashboard page with the client ID
        navigate(`/admin/orders/settlement/Report/${clientId}/${clientName}`);
      };
  return (
    <div>
    <NoIndex />
    <div className="marginRight px-4 mt-4">
      <div className="mb-2 p-2 rounded-2 bg-light border admin-popup "><h2 className="text-center">All Settlement</h2>
        <hr />
  
        {/* Filters */}
        <div className="row mb-3">
          <div className="col-md-4 mb-2">
            <input
              type="text"
              className="form-control"
              placeholder="Search by Organization"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <div className="col-md-4 mb-2">
            <select
              className="form-select"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="">All Status</option>
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </select>
          </div>
          <div className="col-md-4 mb-2">
            <input
              type="date"
              className="form-control"
              value={dateFilter}
              onChange={(e) => setDateFilter(e.target.value)}
            />
          </div>
        </div></div>
        
  
        {/* Table */}
        {Loading ? (
          <div className="text-center">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <div className="scrollable-table border-radius-10-left">
            <table className="table table-bordered table-hover ">
            <thead style={{ borderRadius: "10px" }}>
    <tr className="text-center   py-4">
      <th className="pb-3 th-style ">Organization</th>
      <th className="pb-3 th-style ">User</th>
      <th className="pb-3 th-style ">Code</th>
      <th className="pb-3 th-style ">Email</th>
      <th className="pb-3 th-style ">Contact</th>
     
   
      <th className="pb-3 th-style ">Wallet Balance</th>
      <th className="pb-3 th-style ">Action</th> {/* 👈 NEW */}
     
    </tr>
  </thead>
  <tbody>
    {filteredClients?.map((client) => (
      <tr key={client.id}>
        <td className="pt-4 text-center">{client.organization_name || 'N/A'}</td>
        <td className="pt-4 text-center">{client.us_name || 'N/A'}</td>
        <td className="pt-4 text-center"><strong>{client.us_code || 'N/A'}</strong></td>
        <td className="pt-4 text-center">{client.us_email || 'N/A'}</td>
        <td className="pt-4 text-center">{client.us_contact || client.us_loginid || 'N/A'}</td>
     
        
        <td className="pt-4 text-center">{client.balance || 'N/A'}</td>
<td className="pt-4 text-center cursor-pointer">
  {/* View Settlement */}
  <FileText
    size={22}
    style={{ color: "blue", marginRight: "12px", cursor: "pointer" }}
    onClick={() => viewSettlement(client.us_code, client.organization_name)}
    title="View Settlement"
  />

  {/* View Payment Report */}
  <BarChart2
    size={22}

    style={{ color: "blue", cursor: "pointer" }}
    onClick={() => viewPayoutReport(client.us_code, client.organization_name)}
    title="View Payment Report"
  />
</td>
      
      </tr>
    ))}
  </tbody>
  
            </table>
          </div>
        )}
      </div>
  

  </div>
  )
}

export default AdminOrderSettlement